import React from 'react'

const Dashboard = () => {
  return (
    <div>Welcome to Employee Management System</div>
  )
}

export default Dashboard